import {
  AREA_ERROR,
  AREA_REQUEST,
  AREA_SUCCESS,
} from './types';

const initialState = {
  data   : {},
  error  : null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AREA_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case AREA_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case AREA_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    default:
      return state;
  }
}
